module.exports = __webpack_public_path__ + "img/link-icon.8c59ad47.svg";